<template>
  <div v-if="project" id="project" class="designspec--project">
    <div class="layout">
      <div class="project">
        <ProjectHeader :project="project" :readonly="true" />
        <div class="sections" v-stack-y:md>
          <SpecSection
            :readonly="true"
            v-for="(section, i) in project.sections || []"
            :ref="'section-' + i"
            :key="section.id"
            :section="section"
            :project="project"
          />
        </div>
      </div>
      <div v-if="!!networkError" class="network-error-wrapper w-full container text-center">
        <h1>{{ 'Page not found' | t }}</h1>
        <div
          class="field field--name-body field--type-text-with-summary field--label-hidden field__item"
        >
          <p>{{ 'Sorry about that! Click' | t }} <a href="/">{{ 'here' | t }}</a> {{ 'to return to the home page.' | t }}</p>
        </div>
      </div>
    </div>
    <SloModalView />
  </div>
</template>

<script>
import t from '../../main/i18n';
import {getSharedProject} from '../apis/designspec';
import {ProjectHeader, SpecSection} from '../components';
import SloModalView from '../../../lib/components/SloModalView.vue';

export default {
  components: {
    ProjectHeader,
    SpecSection,
    SloModalView
  },
  beforeRouteEnter(to, from, next) {
    const projectId = Number(to.params.id);
    getSharedProject(projectId, to.params.shareToken)
      .then(project => {
        next(vm => vm.setProject(project));
      })
      .catch(() => {
        next(vm => {
          vm.networkError = true;
        });
      });
  },
  methods: {
    setProject(project) {
      this.project = project;
    }
  },
  data() {
    return {
      project: null,
      networkError: false
    };
  },
  filters: {
    t
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';

.designspec--project {
  .layout {
    display: flex;
  }

  .project {
    width: 100%;
  }

  @media screen and (min-width: 1280px) {
    .project {
      width: 67%;
      margin: 0 auto;
    }
  }
}

.text-sm {
  @include text('sm');
}

.sections {
  padding-top: 20px;
  margin-bottom: 32px;

  article:first-child {
    margin-top: 0 !important;
  }
}

.add-section {
  margin-bottom: 24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms cubic-bezier(0.23, 1, 0.32, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.network-error-wrapper {
  margin-top: 90px;
}
</style>
